import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { DesignSnackListPresenter } from "./presenter";
import { useSnackListQuery } from "../../model";

type Props = {
	hotelID: string;
};

export const DesignSnackListContainer = ({ hotelID }: Props) => {
	const { data } = useSnackListQuery({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <DesignSnackListPresenter hotelID={hotelID} data={data} />;
};

DesignSnackListContainer.displayName = "DesignSnackListContainer";
